module.exports = __webpack_public_path__ + "img/step_four.3ec6866d.jpg";